import { gql } from "@apollo/client";

export const GET_INVENTORIES = gql`
  query GetInventories {
    user {
      inventories {
        inventoryUuid
        createdAt
        updatedAt
        status
      }
    }
  }
`;
